export const persistentStateFeatureKey = 'persistent'

export interface ExtFileManagerFilter {
  accountId?: number
  activePanelId?: number
  executionNumber?: number
  selectedDate?: string
}
